import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import 'moment/locale/es';

import Home from './pages/home';
import Login from './pages/login';
import MeetingDetails from "./pages/salones/meetingDetails";
import PDetails from "./pages/comunicaciones/postDetails";
import UsersDetails from "./pages/usuarios/usersDetails";
import PostEditor from "./pages/comunicaciones/postEditor";
import Comunicaciones from "./pages/comunicaciones/comunicaciones";
import Usuarios from "./pages/usuarios/usuarios";
import Reuniones from "./pages/salones/reuniones";
import Magistrados from "./pages/juntanominadora/PanelUrna";
import PanelMagistrados from "./pages/juntanominadora/PanelAdministrador";
import Perfiles from "./views/juntanominadora/perfiles";
import VotacionDash from "./pages/juntanominadora/PanelCongresista";
import Proyeccion from "./views/juntanominadora/proyeccion";
import ProyeccionElegidos from "./views/juntanominadora/proyeccionElegidos";
import Curul from "./views/juntanominadora/curul";
import DiagramaSimple from "./views/juntanominadora/diagramaSimple";
import DiagramaCompleto from "./views/juntanominadora/diagramaCompleto";
import ReportePrueba from "./views/juntanominadora/reporteprueba";
import ProyeccionVotos from "./views/juntanominadora/proyeccionVotos";
import ProyeccionElegidosBG from "./views/juntanominadora/proyeccionElegidosBG";
import DiagramaCompletoVotos from "./views/juntanominadora/diagramaCompletoVotos";
import DiagramaCompletoImpresion from "./views/juntanominadora/diagramaCompletoImpresion";
import DiagramaCompletoVotosImpresion from "./views/juntanominadora/diagramaCompletoVotosImpresion";
import DiagramaCompletoVotosSistemaCSJ from "./views/juntanominadora/diagramaCompletoVotosSistemaCSJ";
import Diagrama from "./views/juntanominadora/diagrama";

// Componente principal que define todas las rutas del sistema
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" >
          <Route index element={<Home />} /> {/* Ruta principal */}
          <Route path="login">
            <Route index element={<Login />} /> {/* Login */}
          </Route>
          <Route path="votaciones">
            <Route index element={<Magistrados/>} /> {/* Panel de urna / votaciones */}
          </Route>
          <Route path="proyeccionvotos">
            <Route index element={<ProyeccionVotos/>} /> {/* Proyección de votos magistrados */}
          </Route>
          <Route path="proyeccion">
            <Route index element={<Proyeccion/>} /> {/* Proyección general */}
          </Route>
          <Route path="proyeccionelegidos">
            <Route index element={<ProyeccionElegidos/>} /> {/* Proyección de electos */}
          </Route>
          <Route path="proyeccionelegidosbg">
            <Route index element={<ProyeccionElegidosBG/>} /> {/* Proyección de electos con fondo */}
          </Route>
          <Route path="diagrama">
            <Route index element={<Diagrama/>} /> {/* Diagrama general */}
          </Route>
          <Route path="asistencia">
            <Route index element={<Diagrama onlyAsistencia={true}/>} /> {/* Diagrama solo de asistencia */}
          </Route>
          <Route path="diagramasimple">
            <Route index element={<DiagramaSimple/>} /> {/* Diagrama simple */}
          </Route>
          <Route path="diagramacompleto">
            <Route index element={<DiagramaCompleto/>} /> {/* Diagrama completo */}
          </Route>
          <Route path="diagramacompletoimpresion">
            <Route index element={<DiagramaCompletoImpresion/>} /> {/* Diagrama completo para impresión */}
          </Route>
          <Route path="diagramacompletovotos">
            <Route index element={<DiagramaCompletoVotos/>} /> {/* Diagrama completo con votos */}
          </Route>
          <Route path="diagramacompletovotosimpresion">
            <Route index element={<DiagramaCompletoVotosImpresion/>} /> {/* Diagrama completo con votos para impresión */}
          </Route>
          <Route path="diagramacompletovotossistemacsj">
            <Route index element={<DiagramaCompletoVotosSistemaCSJ/>} /> {/* Diagrama votos sistema CSJ */}
          </Route>
          <Route path="diagramacompletovotossistemacsjimpresion">
            <Route index element={<DiagramaCompletoVotosSistemaCSJ/>} /> {/* Diagrama votos sistema CSJ impresión */}
          </Route>
          <Route path="curul">
            <Route index element={<Curul/>} /> {/* Acceso por curul */}
          </Route>
          <Route path="reporteprueba">
            <Route index element={<ReportePrueba/>} /> {/* Reporte de prueba */}
          </Route>
          <Route path="votacion">
            <Route index element={<VotacionDash />} /> {/* Panel de votación para congresista */}
          </Route>
          <Route path="perfiles/:id">
            <Route index element={<Perfiles/>} /> {/* Perfil de congresista por id */}
          </Route>
          <Route path="magistrados">
            <Route index element={<PanelMagistrados/>} /> {/* Panel administrador de magistrados */}
          </Route>
          <Route path="comunicaciones">
            <Route index element={<Comunicaciones />} /> {/* Módulo de comunicaciones */}
          </Route>
          <Route path="usuarios">
            <Route index element={<Usuarios />} /> {/* Módulo de usuarios */}
          </Route>
          <Route path="reuniones">
            <Route index element={<Reuniones />} /> {/* Módulo de reuniones */}
          </Route>
          <Route path="/publicaciones/:id" >
            <Route index element={<PDetails />} /> {/* Detalle de publicación */}
          </Route>
          <Route path="/editar/publicaciones/:id" >
            <Route index element={<PostEditor />} /> {/* Editor de publicación */}
          </Route>
          <Route path="/reuniones/:id" >
            <Route index element={<MeetingDetails />} /> {/* Detalle de reunión */}
          </Route>
          <Route path="/usuarios/:id" >
            <Route index element={<UsersDetails />} /> {/* Detalle de usuario */}
          </Route>
        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;